import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, buttonSizes, buttonTypes } from '../shared/Button';
import EulaPdf from '../../assets/sara_eula.pdf';
import { PDFObject } from 'react-pdfobject';
import { connect } from 'react-redux';
import { acceptEula } from '../../redux/actions/eulaActions';
import RedirectToMain from './RedirectToMain';
import { FormattedMessage } from 'react-intl';
import { cancelText } from '../shared/SharedInternationalizations';

/**
 * EULA display component to display when the user needs to accept the EULA during the login process
 */
export const UnconnectedEula = (props) => {
  const navigate = useNavigate();
  const { eula } = props;
  /**
   * Function to trigger the user EULA acceptance action
   * @fires dispatch#acceptEula - Triggers the acceptEula Redux action with the navigate function
   */
  function handleAccept() {
    props.dispatch(acceptEula(navigate));
  }
  function redirect(params) {
    if (eula) {
      return <RedirectToMain data-test="redirect" />;
    } else {
      return '';
    }
  }

  const acceptEulaText = (
    <FormattedMessage
      id="eula.acceptEulaText"
      defaultMessage="Accept EULA"
      description="Help text."
    />
  );
  //Force reload of PDF to avoid caching issues
  //this will allow us to dynamically update the pdf file
  // r/sara-eula-link.pdf which is a symbolic link to
  // the actual EULA file on the server (r/static/media/sara_eula.*.pdf)
  const pdfUrl = `${EulaPdf}?nocache=${new Date().getTime()}`; // Append a timestamp to prevent caching issues
  console.log('Eula: pdfUrl: ', pdfUrl);


  return (
    <div className="eula__display eula__display--full">
      <PDFObject url={pdfUrl} width="100%" data-test="pdf-component" />
      <div className="eula-display__buttons-container">
        <a className="link-text margin-right-10" href="/index.php?mode=logout">
          {cancelText}
        </a>

        <Button
          data-test="accept-button"
          text={acceptEulaText}
          buttonType={buttonTypes.success}
          buttonSize={buttonSizes.medium}
          onClick={handleAccept}
        />
      </div>
      {redirect()}
    </div>
  );
};

const mapStateToProps = (state) => {
  const eula = state.currentUser.eulaAccepted;

  return {
    eula,
  };
};

export default (connect(mapStateToProps)(UnconnectedEula));
